import React, { useState, useEffect } from 'react';
import { usersAPI } from '../services/api';
import { format } from 'date-fns';
import UserModal from '../components/UserModal';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setLoading(true);
    try {
      const response = await usersAPI.getAll();
      setUsers(response.data.users);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateUser = () => {
    setSelectedUser(null);
    setShowModal(true);
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo utente?')) {
      return;
    }

    try {
      await usersAPI.delete(userId);
      loadUsers();
    } catch (error) {
      alert(error.response?.data?.error || 'Errore durante l\'eliminazione');
    }
  };

  const handleModalClose = (reload) => {
    setShowModal(false);
    setSelectedUser(null);
    if (reload) {
      loadUsers();
    }
  };

  if (loading) {
    return <div className="loading">Caricamento...</div>;
  }

  return (
    <div>
      <div className="header">
        <h1>Gestione Utenti</h1>
        <button className="btn btn-success" onClick={handleCreateUser}>
          + Nuovo Utente
        </button>
      </div>

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Nome Completo</th>
              <th>Email</th>
              <th>Ruolo</th>
              <th>Stato</th>
              <th>Ultimo Accesso</th>
              <th>Creato</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.user_id}>
                <td><strong>{user.username}</strong></td>
                <td>{user.full_name}</td>
                <td>{user.email}</td>
                <td>
                  <span style={{
                    padding: '3px 8px',
                    borderRadius: '3px',
                    fontSize: '12px',
                    background: user.role === 'admin' ? '#ffeaa7' : '#dfe6e9',
                    color: user.role === 'admin' ? '#d63031' : '#2d3436',
                    fontWeight: 'bold'
                  }}>
                    {user.role.toUpperCase()}
                  </span>
                </td>
                <td>
                  <span style={{
                    padding: '3px 8px',
                    borderRadius: '3px',
                    fontSize: '12px',
                    background: user.is_active ? '#d4edda' : '#f8d7da',
                    color: user.is_active ? '#155724' : '#721c24'
                  }}>
                    {user.is_active ? 'Attivo' : 'Disabilitato'}
                  </span>
                </td>
                <td>
                  {user.last_login 
                    ? format(new Date(user.last_login), 'dd/MM/yyyy HH:mm')
                    : 'Mai'
                  }
                </td>
                <td>{format(new Date(user.created_at), 'dd/MM/yyyy')}</td>
                <td>
                  <button
                    className="btn btn-primary"
                    style={{ padding: '5px 10px', fontSize: '12px', marginRight: '5px' }}
                    onClick={() => handleEditUser(user)}
                  >
                    Modifica
                  </button>
                  <button
                    className="btn btn-danger"
                    style={{ padding: '5px 10px', fontSize: '12px' }}
                    onClick={() => handleDeleteUser(user.user_id)}
                  >
                    Elimina
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <UserModal
          user={selectedUser}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

export default Users;

